import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import _ from 'lodash'
import moment from 'moment'

import { BaseContext } from '../theme.context'
import { history } from '../../store'
import Table from '../../Components/Table.component'
import { FORM_DETAIL } from '../../actions'

export class FormsListComponent extends Component {
  static contextType = BaseContext

  componentDidMount() {
    this.context.onChangeColor()
    this.context.onChangeleftButton(
      true,
      null,
      history.goBack,
    )
  }

  render = () => {
    const {
      classes,
      formsPoints,
      headers,
      getDetail,
      titleList,
    } = this.props

    return (
      <Container
        fixed
        className={classes.fullHeight}
      >
        <Grid
          container
          justify='center'
          alignItems='center'
          className={classes.fullHeight}
        >
          <Grid
            item
            xs={12}
            className={classes.tableContainer}
          >
            <Table
              className={classes.table}
              headCells={headers}
              rows={formsPoints}
              onClickRow={row => getDetail({
                id: row._id,
                url: `${this.props.location.pathname}/detail/${row._id}`,
              })}
              title={titleList}
            />
          </Grid>
        </Grid>
      </Container>
    )
  }
}

export const mapStateToProps = (state, props) => {
  const {
    match: {
      params: {
        type: statusForm,
      }
    }
  } = props
  const {
    Forms: {
      formsPoints,
      forms,
    },
    Points: { data: points },
    Login: { profile },
  } = state

  const pointsKeyed = _.keyBy(points, '_id')
  const formsKeyed = _.keyBy(forms, '_id')

  const formsPointsMerge = _.map(formsPoints, formPoint => {
    const form = formsKeyed[formPoint.form_id] || {}
    const point = pointsKeyed[formPoint.point_id] || {}

    if (!point.name) return null

    return {
      ...formPoint,
      form,
      point,
      user: profile.email,
      created_at: moment(new Date(formPoint.created_at)).format('DD/MM/YYYY HH:mm:ss'),
      datetime: new Date(formPoint.created_at).getTime(),
    }
  })
  const formsPointsOrdered = _.orderBy(formsPointsMerge, ['datetime'],['desc'])
  const formsPointsGrouped = _.groupBy(_.compact(formsPointsOrdered), 'finalize')
  const formsPointsFilter = statusForm === 'finalized'
    ? formsPointsGrouped.true || []
    : formsPointsGrouped.false || []
  const titleList = statusForm === 'finalized'
    ? 'Formularios Finalizados'
    : 'Formularios Pendientes'

  const headers = [{
    key: 'form.name',
    label: 'Formulario',
  }, {
    key: 'point.name',
    label: 'Punto',
  }, {
    key: 'user',
    label: 'Usuario',
  }, {
    key: 'created_at',
    label: 'Fecha creación',
  }]

  return {
    headers,
    formsPoints: formsPointsFilter,
    titleList,
  }
}

const mapDispatchtoProps = dispatch => ({
  getDetail: ({ id, url }) => dispatch(FORM_DETAIL({ id, url }))
})

const useStyles = theme => ({
  fullHeight: { height: '100%' },
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  tableContainer: {
    height: '80%',
  },
  table: {
    height: 'calc(100vh - 220px)',
    margin: 0,
    minWidth: 650,
  },
})

export default compose(
  connect(mapStateToProps, mapDispatchtoProps),
  withStyles(useStyles),
)(FormsListComponent)